export const PanelClientsEditAccountsMessages = {
    GetTradingClientFailed: {
        key: 'GetTradingClientFailed',
        message: 'Error while communication with the server. Can\'t get individual trading information.'
    },
    NavigateToAccountForbidden: {
        key: 'NavigateToAccountForbidden',
        message: 'The access to selected account is restricted.'
    }
};
